import { userCollection } from './chunk-FQN2HH6G.mjs';
import { errorProxy } from './chunk-JMNS64QU.mjs';
import { userSchema } from './chunk-2CIDNLJ5.mjs';
import { NotFoundError, UnknownError, AuthenticationError } from './chunk-CN37FTGW.mjs';
import { object, string, date, union, literal } from 'zod';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { fromPromise } from 'neverthrow';
import { Observable } from 'rxjs';

object({
  firstName: string(),
  lastName: string(),
  kana: object({
    firstName: string(),
    lastName: string()
  }),
  email: string().email(),
  tel: string(),
  address: object({
    postcode: string(),
    state: string(),
    city: string(),
    address1: string(),
    address2: string().default("")
  }),
  birthday: date(),
  work: string(),
  bank: object({
    name: string(),
    branch: string(),
    symbol: string().default(""),
    // 銀行コード（4桁）: 既存ドキュメントには存在しないため optional
    code: string().optional(),
    // 支店番号（3桁）: 既存ドキュメントには存在しないため optional
    branchCode: string().optional(),
    accountType: union([literal(1), literal(2)]),
    accountNumber: string(),
    accountHolder: string()
  })
});
var userOutputSchema = userSchema;
var userBlocFactory = ({ db }) => {
  const userRef = userCollection(db);
  const stream = ({ user }) => {
    const userDoc = doc(userRef, user.id);
    return new Observable((subscriber) => {
      return onSnapshot(userDoc, {
        next: (snapshot) => {
          const data = snapshot.data();
          if (!data) return subscriber.error(new NotFoundError());
          const result = userOutputSchema.safeParse({
            ...data,
            id: snapshot.id,
            birthday: data.birthday.toDate()
          });
          if (result.success) subscriber.next(result.data);
          else subscriber.error(new UnknownError());
        },
        error: () => subscriber.error(new AuthenticationError()),
        complete: () => subscriber.complete()
      });
    });
  };
  const edit = ({ user }, data) => {
    const userDoc = doc(userRef, user.id);
    return fromPromise(updateDoc(userDoc, data), errorProxy("edit user failed"));
  };
  return {
    stream,
    edit
  };
};

export { userBlocFactory, userOutputSchema };
//# sourceMappingURL=chunk-3ACS42EJ.mjs.map
//# sourceMappingURL=chunk-3ACS42EJ.mjs.map